import React from 'react';
import { Box, Table, TableBody, TableCell, Grid, Tooltip, TableContainer, TableHead, TableRow, Paper, TableSortLabel, TablePagination, Snackbar, Alert, Chip, Checkbox, Modal, IconButton, TextField, Typography, FormControl, Dialog, DialogContent, DialogContentText, Select, MenuItem, Menu } from '@mui/material';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Add as AddIcon, Search, FilterAlt, CheckCircle, Cancel, Refresh, Delete } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import FilterListIcon from '@mui/icons-material/FilterList';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import { fetchUser, getbroker, editUserByRowSelection, saveUser, activateAndDeactivateUsers, generateExportExcelforUsers, getUserAlaisById, getUserExists, getUserAlaisExists, getReportingUsersByUserId, getReportingToUsersByUserId, removeReportingUsersByUserId } from '../ApiSevices/UserMasterApis';
import { fetchRole, getRoUsersByBrokerId } from '../ApiSevices/RoleMasterApis';
import { UserRole, decodeJwt, rolenum } from '../Pages/ApiCommonService'
import { GridTable } from '../Sidebar/SidebarStyles';
import ConfirmationDialogComponent from '../Common/ConfirmationDialogComponent';

type Order = 'asc' | 'desc';

interface Row {
  CreatedOn: any;
  UpdatedOn: any;
  vchLname: string;
  ObjectId: string;
  vchMname: string;
  vchMobile: string;
  ID: string;
  vchFname: string;
  vchEmail: string;
  AuthType: string;
  SendEmail: boolean;
  RoleID: any;
  bitActive: boolean;
  vchUser_Name: string;
  Broker_ID: any;
  vchPassword: any;
  selectedRow: any;
  AliasEmails?: string[];
  initialSelectedRow: any;
  ConfirmPassword?: string;
  BranchCode: any;
  Actions?: string;
  Status: any;
  IsRoUser: boolean;
  ReportingToUser: any;
}

interface HeadCell {
  id: keyof Data;
  label: string;
  disableSort?: boolean;
}
interface Broker {
  Broker_ID: number;
  vchBrokerName: string;
  bitActive: boolean;
}

interface Data {
  vchFname: string;
  vchEmail: string;
  AuthType: string;
  SendEmail: boolean;
  RoleID: any;
  CreatedOn: string;
  vchUser_Name: string;
  BranchCode: any;
  Actions?: string;
  Status: any;
  IsRoUser: any;
}

interface TableProps {
  displaysidebar: boolean;
}

interface State {
  rows: Row[];
  roles: any[];
  alais: any[];
  roUsers: any[];
  roReportUsers: any[];
  order: Order;
  orderBy: keyof Data;
  page: number;
  rowsPerPage: number;
  snackbarOpen: boolean;
  snackbarMessage: string;
  snackbarSeverity: 'success' | 'error' | 'info' | 'warning';
  loading: boolean;
  selected: any;
  modalOpen: boolean;
  modalReportUserOpen: boolean;
  editMode: boolean;
  emailError: string,
  noError: string,
  pwdError: string,
  brokers: Broker[],
  showPassword: boolean,
  showConfirmPassword: boolean,
  totalCount: any;
  selectedRow: any;
  initialSelectedRow: any;
  searchTerm: string;
  searchQuery: any;
  statusFilterAnchorEl: null;
  selectedStatusFilter: '';
  aliasEmails: string[];
  initialAliasEmails: string[];
  aliasEmailErrors: string[];
  broker: number;
  UserId: any;
  Role_Id: any;
  confirmDialog: boolean;
  iconData: any;
  validationErrors: any;
  viewUserDialogOpen: any;
  isRoUserFilter: 'All' | 'true' | 'false';
  isRoUserFilterAnchor: HTMLElement | null;
  selectedRUser: any;
  reportingUserAnchorEl: HTMLElement | null;
  reportPage: number;
  reportRowsPerPage: number;
  confirmationDialog: {
    isOpen: boolean,
    recordId: number,
    message: string,
    activate: boolean,
    isDelete?: boolean
  }
}

// function getComparator<T>(order: 'asc' | 'desc', orderBy: keyof T): (a: T, b: T) => number {
//   return (a, b) => {
//     const aValue = a[orderBy];
//     const bValue = b[orderBy];

//     if (aValue == null) return 1;
//     if (bValue == null) return -1;

//     const comparison = aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
//     return order === 'desc' ? -comparison : comparison;
//   };
// }

function getComparator<T>(order: 'asc' | 'desc', orderBy: keyof T, roles: any[]): (a: T, b: T) => number {
  return (a, b) => {
    let aValue = a[orderBy];
    let bValue = b[orderBy];

    if (orderBy === 'RoleID') {
      const aRole = roles.find(r => r.RoleId === aValue);
      const bRole = roles.find(r => r.RoleId === bValue);
      aValue = aRole?.RoleName || '';
      bValue = bRole?.RoleName || '';
    }

    if (aValue == null) return 1;
    if (bValue == null) return -1;

    const comparison = aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
    return order === 'desc' ? -comparison : comparison;
  };
}


const textFieldStyles = {
  "& .MuiInputBase-root": { height: "35px" },
  "& .MuiInputLabel-root": { position: "relative", top: "19.5px", fontSize: "11.5px" },
  "& .MuiOutlinedInput-input": { padding: "10px 20px" }
};

const selectStyles = {
  "& .MuiInputBase-root": { height: "35px" },
  "& .MuiSelect-select": { padding: "6px 20px", fontSize: "14px" },
  "& .MuiSelect-placeholder": { color: "rgba(0, 0, 0, 0.54)", fontSize: "16px" },
};

class UserMaster extends React.Component<TableProps, State> {
  debounceTimers: any;
  RoUserEnabledRoles = [rolenum.CSR];
  constructor(props: TableProps) {
    super(props);
    this.state = {
      rows: [],
      roles: [],
      alais: [],
      roUsers: [],
      roReportUsers: [],
      brokers: [],
      order: 'desc',
      orderBy: 'CreatedOn',
      page: 0,
      rowsPerPage: 10,
      snackbarOpen: false,
      snackbarMessage: '',
      snackbarSeverity: 'success',
      loading: false,
      modalOpen: false,
      modalReportUserOpen: false,
      editMode: false,
      selected: null,
      emailError: '',
      noError: '',
      pwdError: '',
      showPassword: false,
      showConfirmPassword: false,
      selectedRow: {},
      initialSelectedRow: {},
      totalCount: '',
      searchTerm: '',
      searchQuery: '',
      statusFilterAnchorEl: null,
      selectedStatusFilter: '',
      aliasEmails: [],
      initialAliasEmails: [],
      aliasEmailErrors: [],
      broker: 0,
      UserId: 0,
      Role_Id: '',
      confirmDialog: false,
      iconData: [],
      validationErrors: {},
      viewUserDialogOpen: false,
      isRoUserFilter: 'All',
      isRoUserFilterAnchor: null,
      selectedRUser: null,
      reportingUserAnchorEl: null,
      reportPage: 0,
      reportRowsPerPage: 10,
      confirmationDialog: {
        isOpen: false,
        recordId: 0,
        message: "",
        activate: false
      }
    };
  }

  componentDidMount() {
    this.fetchUsers();
    this.fetchRoles();
    // this.getBrokers();

    const token = sessionStorage.getItem('token');
    if (token) {
      const decodedToken = decodeJwt(token);
      if (decodedToken) {
        const brokerId = decodedToken?.BrokerId;
        this.setState({ broker: parseInt(brokerId), Role_Id: decodedToken.RoleId, UserId: decodedToken.UserId });
      } else {
        console.warn("Token decoding failed or returned null");
      }
    }
  }

  getBrokers = async () => {
    this.setState({ loading: true });

    try {
      const fetchResponse = await getbroker();
      if (fetchResponse && fetchResponse?.length > 0) {
        this.setState({ brokers: fetchResponse });
      }

    } catch (error) {
      console.error('Error fetching brokers:', error);
    } finally {
      this.setState({ loading: false });
    }
  };

  fetchRoles = async () => {
    this.setState({ loading: true });

    try {
      const fetchResponse = await fetchRole();
      if (fetchResponse && fetchResponse?.length > 0) {
        this.setState({ roles: fetchResponse });
      }

    } catch (error) {
      console.error('Error fetching roles:', error);
    } finally {
      this.setState({ loading: false });
    }
  };

  fetchUsers = async () => {
    this.setState({ loading: true });
    const { page, rowsPerPage } = this.state;
    try {
      const fetchResponse = await fetchUser(page, rowsPerPage, "");
      if (fetchResponse?.data.length > 0) {
        this.setState({ rows: fetchResponse?.data, totalCount: fetchResponse?.totalCount });
        this.showSnackbar('Users fetched successfully!', 'success');
      }
    } catch (error) {
      console.error('Error fetching users:', error);
      this.showSnackbar('Failed to fetch users.', 'error');
    } finally {
      this.setState({ loading: false });
    }
  };

  async fetchROUserList() {
    this.setState({ loading: true });
    const { broker } = this.state;
    try {
      const fetchResponse = await getRoUsersByBrokerId(broker);
      if (fetchResponse && fetchResponse?.length > 0) {
        this.setState({ roUsers: fetchResponse });
      }

    } catch (error) {
      console.error('Error fetching roles:', error);
    } finally {
      this.setState({ loading: false });
    }
  }

  handleExportExcel = async () => {
    const { Role_Id } = this.state;

    this.setState({ loading: true });
    try {
      const fileBlob = await generateExportExcelforUsers();

      const url = window.URL.createObjectURL(fileBlob);
      const link = document.createElement('a');
      link.href = url;

      const filename = `${Role_Id === UserRole.ExdionAdmin
        ? 'ExdionAdmin'
        : Role_Id === UserRole.BrokerAdmin
          ? 'BrokerAdmin'
          : ''
        }_user lists.xlsx`;

      link.setAttribute('download', filename);

      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error in exporting users data:', error);
    } finally {
      this.setState({ loading: false });
    }
  };


  showSnackbar = (message: string, severity: 'success' | 'error' | 'info' | 'warning') => {
    this.setState({ snackbarOpen: true, snackbarMessage: message, snackbarSeverity: severity });
  };

  handleCloseSnackbar = () => {
    this.setState({ snackbarOpen: false });
  };

  handleCloseModal = () => {
    this.setState({ modalOpen: false, selectedRow: null, emailError: '', noError: '', pwdError: '', validationErrors: {}, aliasEmailErrors: [] });
  };

  isFormValid() {
    const { selectedRow, editMode, initialSelectedRow } = this.state;
    const baseValid =
      selectedRow?.vchFname?.trim() !== '' &&
      selectedRow?.vchLname?.trim() !== '' &&
      selectedRow?.vchEmail?.trim() !== '' &&
      selectedRow?.RoleID !== '' && selectedRow?.RoleID !== undefined &&
      selectedRow?.AuthType?.trim() !== ''

    const hasChanges = JSON.stringify(selectedRow) !== JSON.stringify(initialSelectedRow);

    if (editMode) {
      return hasChanges && baseValid;
    } else {
      return baseValid;
    }
  }

  handleRequestSort = (property: keyof Data) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc';
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property
    });
  };

  handleChangePage = (_: unknown, newPage: number) => {
    this.setState({ page: newPage }, () => {
      this.fetchUsers();
    });
  };

  handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    this.setState({ rowsPerPage: newRowsPerPage, page: 0 }, () => {
      this.fetchUsers();
    });
  };

  //   handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
  //     this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 }, () => {
  //       this.fetchUsers();
  //   });
  // };

  // isSelected = (id: string) => this.state.selected?.indexOf(id) !== -1;

  // handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   if (event.target.checked) {
  //     const newSelecteds = this.state.rows.map((n) => n.ID);
  //     this.setState({ selected: newSelecteds });
  //     return;
  //   }
  //   this.setState({ selected: [] });
  // };

  // handleClick = (event: React.MouseEvent<unknown>, id: string) => {
  //   const selectedIndex = this.state.selected?.indexOf(id);
  //   let newSelected: string[] = [];

  //   if (selectedIndex === -1) {
  //     newSelected = newSelected.concat(this.state.selected, id);
  //   } else if (selectedIndex === 0) {
  //     newSelected = newSelected.concat(this.state.selected.slice(1));
  //   } else if (selectedIndex === this.state.selected.length - 1) {
  //     newSelected = newSelected.concat(this.state.selected.slice(0, -1));
  //   } else if (selectedIndex > 0) {
  //     newSelected = newSelected.concat(
  //       this.state.selected.slice(0, selectedIndex),
  //       this.state.selected.slice(selectedIndex + 1),
  //     );
  //   }

  //   this.setState({ selected: newSelected });
  // };

  handleAddClick = () => {
    if (this.RoUserEnabledRoles.includes(this.state.Role_Id)) {
      this.fetchROUserList();
    }
    this.setState({
      modalOpen: true,
      selectedRow: {
        vchFname: '', vchEmail: '', vchUser_Name: '', RoleID: '', CreatedOn: undefined,
        SendEmail: '', AuthType: '', vchMname: '', vchLname: '', vchMobile: '', BranchCode: ''
      },
      editMode: false
    });
  };

  handleOpenEditDrawer = (id: any) => async (event: React.MouseEvent) => {
    event.stopPropagation();
    this.setState({ loading: true });
    try {
      // Fetch the selected user based on the ID
      const getDataByrowIdRes = await editUserByRowSelection(id);
      const getUserAliasById = await getUserAlaisById(id);

      if (getUserAliasById) {
        const userAliases = getUserAliasById
          .filter((f: any) => f?.UserID === id)
          .map((f: any) => f?.Email);  // <-- Extract just the emails

        this.setState({ aliasEmails: userAliases || [], initialAliasEmails: userAliases || [], });
      }

      const fetchResponse = await getRoUsersByBrokerId(this.state.broker);
      if (fetchResponse && fetchResponse?.length > 0) {
        this.setState({ roUsers: fetchResponse });
      }

      if (getDataByrowIdRes) {
        this.setState({
          modalOpen: true,
          editMode: true,
          selectedRow: { ...getDataByrowIdRes },
          initialSelectedRow: { ...getDataByrowIdRes },
        });
      }
    } catch (error) {
      this.setState({ aliasEmails: [], initialAliasEmails: [] });
      this.showSnackbar('Failed to edit the selected user.', 'error');
    } finally {
      this.setState({ loading: false });
    }
  };

  handleFormChange = (field: keyof Row, value: string | number | Date | boolean | string[]) => {
    this.setState((prevState) => ({
      selectedRow: prevState.selectedRow ? { ...prevState.selectedRow, [field]: value } : null
    }));
  };

  /** HANDLE SAVE (CREATE OR EDIT) */
  handleSaveRow = async () => {
    const { selectedRow, editMode, rows } = this.state;
    const errors: any = {};

    if (!selectedRow?.vchFname?.trim()) errors.vchFname = "*FirstName is mandatory";
    if (!selectedRow?.vchLname?.trim()) errors.vchLname = "*LastName is mandatory";
    if (!selectedRow?.vchEmail?.trim()) errors.vchEmail = "*Email is mandatory";
    if (!selectedRow?.RoleID) errors.RoleID = "*Role is mandatory";
    if (!selectedRow?.AuthType?.trim()) errors.AuthType = "*AuthType is mandatory";
    // if (selectedRow?.IsRoUser && !selectedRow.ReportingToUser) errors.ReportingToUser = "Ro User is Mandatory"

    if (Object.keys(errors).length > 0) {
      this.setState({ validationErrors: errors });
      return;
    }

    this.setState({ loading: true, validationErrors: {} });
    const isEdit = !!editMode;

    this.setState({ loading: true });
    if (!selectedRow) return;

    const primary_email = selectedRow?.vchEmail;
    if (primary_email) {
      const response = await getUserAlaisExists(primary_email);

      if (response?.exists) {
        alert("Primaryuser is already added as a alaisEmail");
        this.setState({ loading: false });
        return;
      }
    }

    try {
      const saveResData = await saveUser(selectedRow, editMode);
      if (saveResData) {
        if (isEdit) {
          this.setState({
            rows: rows?.map(row => (row?.ID === selectedRow.ID ? selectedRow : row)),
            modalOpen: false,
            selectedRow: null,
          });
          this.showSnackbar(`${selectedRow?.vchUser_Name} updated successfully!`, 'success');
        } else {
          this.setState({
            rows: [saveResData, ...rows],
            modalOpen: false,
            selectedRow: null,
            order: 'desc',
            orderBy: 'CreatedOn',
          });
          this.showSnackbar(`New userName ${selectedRow?.vchUser_Name} created successfully!`, 'success');
          this.fetchUsers();
        }
      }
    } catch (error) {
      console.error("Error creating or updating user:", error);
      this.showSnackbar('Failed to create new or update existing record.', 'error');
    } finally {
      this.setState({ loading: false });
    }
  };

  getRoUserList(IsRoUser: boolean) {
    if (IsRoUser) {
      this.fetchROUserList();
    } else {
      this.setState({ roUsers: [] });
    }
    this.handleFormChange("ReportingToUser", 0);
  }

  handleActivateUsers = async (status: boolean) => {
    const { selected } = this.state;
    this.setState({ loading: true });

    const flag = status ? 'Activated' : 'Deactivated';
    try {
      await activateAndDeactivateUsers(selected?.ID, status);

      this.showSnackbar(`The selected user is ${flag} successfully!`, 'success');
      this.setState((prevState) => ({
        rows: prevState?.rows?.map((row) =>
          row?.ID === selected?.ID ? { ...row, bitActive: status } : row
        ),
        selected: null,
      }));
    } catch (error) {
      console.error("Error updating user status:", error);
      this.showSnackbar('Failed to activate or de-activate the selected users.', 'error');
    } finally {
      this.setState({ loading: false, confirmDialog: false });
    }
  };

  // getSelectedStatusFlags = () => {
  //   const { selected, rows } = this.state;
  //   if (!selected || selected.length === 0) return { showActivate: false, showDeactivate: false };

  //   const selectedRows = rows.filter(row => selected.includes(row.ID));
  //   const allActive = selectedRows.every(row => row.bitActive);
  //   const allInactive = selectedRows.every(row => !row.bitActive);

  //   return {
  //     showActivate: allInactive || (!allActive && !allInactive),
  //     showDeactivate: allActive || (!allActive && !allInactive),
  //   };
  // };

  validatePasswords(password: any, confirmPassword: any) {
    if (this.state.editMode) return;
    if (password && confirmPassword) {
      const pwdError = password !== confirmPassword ? "Passwords do not match" : "";
      this.setState({ pwdError });
    }
  }

  handleSearchChange = (event: any) => {
    const term = event.target.value.trim();
    this.setState({ searchTerm: term }, () => {
      if (term === '') {
        this.setState({ searchQuery: '' }, () => {
          this.fetchUsers();
        });
      }
    });
  };

  handleSearchClick = async () => {
    this.setState({ loading: true, searchQuery: this.state.searchTerm });
    try {
      const searchResponse = await fetchUser(0, this.state.rowsPerPage, this.state.searchTerm.replace(/\s/g, ''));
      if (searchResponse && searchResponse?.data?.length > 0) {
        this.setState({ rows: searchResponse?.data, totalCount: searchResponse?.totalCount });
      }
      else if (searchResponse?.data?.length == 0) {
        this.setState({ totalCount: searchResponse?.totalCount });
      }
    } catch (error) {
      console.error('Error in searching user:', error);
      this.showSnackbar('Failed to searching user.', 'error');
    } finally {
      this.setState({ loading: false });
    }
  };

  handleStatusFilterClick = (event: any) => {
    this.setState({ statusFilterAnchorEl: event.currentTarget });
  };

  handleStatusFilterClose = () => {
    this.setState({ statusFilterAnchorEl: null });
  };

  handleStatusFilterSelect = (statusKey: any) => {
    this.setState({
      selectedStatusFilter: statusKey,
      statusFilterAnchorEl: null,
    });
  };

  handleAliasEmailChange = (index: any, value: any) => {
    const aliasEmails = [...this.state.aliasEmails];
    aliasEmails[index] = value;
    this.setState({ aliasEmails });
  };

  addAliasEmailField = () => {
    this.setState((prevState) => ({
      aliasEmails: [...prevState.aliasEmails, ''],
    }));
  };

  removeAliasEmailField = (index: any) => {
    const aliasEmails = [...this.state.aliasEmails];
    aliasEmails.splice(index, 1);
    this.setState({ aliasEmails });
  };

  handleOpenConfirmDialog = (row: any) => {
    this.setState({ confirmDialog: true, iconData: row?.bitActive, selected: row });
  };

  handleCloseConfirmDialog = () => {
    this.setState({ confirmDialog: false });
  };

  clearValidationError = (field: any) => {
    const { validationErrors } = this.state;
    if (validationErrors[field]) {
      const updatedErrors = { ...validationErrors };
      delete updatedErrors[field];
      this.setState({ validationErrors: updatedErrors });
    }
  }

  clearRoUsers(value: number) {
    if (!this.RoUserEnabledRoles.includes(value)) {
      this.handleFormChange("IsRoUser", false);
      this.handleFormChange("ReportingToUser", 0);
    }
  }

  handleRemoveReportingUser = async (ID: any) => {
    this.setState({ loading: true });
    try {
      await removeReportingUsersByUserId(ID);
      this.setState((prevState) => {
        const updatedUsers = (prevState.roReportUsers || []).filter(
          (item: any) => item.ID !== ID
        );
        const maxPage = Math.max(0, Math.ceil(updatedUsers.length / prevState.reportRowsPerPage) - 1);
        return {
          roReportUsers: updatedUsers,
          reportPage: Math.min(prevState.reportPage, maxPage),
        } as Pick<State, 'roReportUsers' | 'reportPage'>;
      });
      this.showSnackbar('Reporting user removed successfully!', 'success');
    } catch (error) {
      console.error('Error removing reporting user:', error);
      this.showSnackbar('Failed to remove reporting user.', 'error');
    } finally {
      this.setState({ loading: false });
    }
  };

  handleViewUser = async (row: any, event: React.MouseEvent<HTMLElement>) => {
    this.setState({ loading: true });
    try {
      const anchorEl = event.currentTarget;
      let reportingUsers = [];

      if (row?.IsRoUser === true) {
        reportingUsers = await getReportingUsersByUserId(row?.ID);
      } else {
        reportingUsers = await getReportingToUsersByUserId(row?.ID);
      }

      this.setState({
        selectedRUser: row,
        roReportUsers: reportingUsers,
        reportingUserAnchorEl: anchorEl,
        modalReportUserOpen: true,
        reportPage: 0,
      });
    } catch (error) {
      console.error('Error in exporting users data:', error);
    } finally {
      this.setState({ loading: false });
    }
  };

  handleCloseReportingUsers = () => {
    this.setState({
      modalReportUserOpen: false,
      reportingUserAnchorEl: null,
      selectedRUser: null,
      reportPage: 0,
    });
  };

  handleReportPageChange = (_: unknown, newPage: number) => {
    this.setState({ reportPage: newPage });
  };

  handleReportRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ reportRowsPerPage: parseInt(event.target.value, 10), reportPage: 0 });
  };

  handleIsRoUserFilterClick = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({
      isRoUserFilterAnchor: event.currentTarget,
    });
  };

  handleIsRoUserFilterClose = () => {
    this.setState({
      isRoUserFilterAnchor: null,
    });
  };

  handleIsRoUserFilterChange = (value: 'All' | 'true' | 'false') => {
    this.setState({
      isRoUserFilter: value,
      isRoUserFilterAnchor: null,
    });
  };

  getRoleName = (roleNumber: number): string | undefined => {
    return Object.keys(rolenum).find(
      key => rolenum[key] === roleNumber
    );
  };


  onConfirmationDialog = async (): Promise<void> => {
    this.setState({ loading: true });
    try {
      const { confirmationDialog } = this.state;
      this.handleRemoveReportingUser(confirmationDialog?.recordId);

      this.setState({
        confirmationDialog: {
          isOpen: false,
          recordId: 0,
          message: "",
          activate: false,
          isDelete: false
        }
      });
    } catch (e) {
      console.error(e);
    }
    finally {
      this.setState({ loading: false });
    }
  }

  handleDeleteConfirmation(user: any) {
    this.setState({
      confirmationDialog: {
        isOpen: true,
        recordId: user.ID,
        message: `Are you sure want to delete the User ${user?.vchEmail}`,
        activate: false
      }
    });
  }

  render() {
    const { displaysidebar } = this.props;
    // const { showActivate, showDeactivate } = this.getSelectedStatusFlags();
    const { rows, alais, order, modalOpen, modalReportUserOpen, orderBy, page, loading, editMode, rowsPerPage, snackbarOpen, selectedRow, confirmDialog, snackbarMessage, snackbarSeverity, roles, broker, UserId, totalCount, selectedStatusFilter, aliasEmails, iconData, Role_Id, roUsers, roReportUsers, reportPage, reportRowsPerPage, confirmationDialog } = this.state;
    const pagedReportUsers = (roReportUsers || []).slice(reportPage * reportRowsPerPage, reportPage * reportRowsPerPage + reportRowsPerPage);

    const headCells: HeadCell[] = [
      { id: 'vchFname', label: 'User Name', disableSort: true },
      { id: 'vchEmail', label: 'User Email', disableSort: true },
      { id: 'RoleID', label: 'Role', disableSort: true },
      { id: 'BranchCode', label: 'Branch Code', disableSort: true },
      { id: 'AuthType', label: 'Auth Type', disableSort: true },
      { id: 'SendEmail', label: 'Send Email', disableSort: true },
      { id: 'Status', label: 'Status', disableSort: true },
      { id: 'IsRoUser', label: 'IsRoUser', disableSort: true },
      { id: 'Actions', label: 'Actions', disableSort: true }
    ];


    const roleMap: Record<string, number> = Object.keys(UserRole)
      .filter(key => isNaN(Number(key)))
      .reduce((acc, key) => {
        acc[key.toLowerCase()] = UserRole[key as keyof typeof UserRole];
        return acc;
      }, {} as Record<string, number>);

    const sortedRows = rows?.filter((row: any) => {
      const statusChange = row?.bitActive ? "Active" : "InActive";
      const email = row?.vchEmail?.toLowerCase() || '';
      const fullName = `${row?.vchFname || ''} ${row?.vchLname || ''}`.toLowerCase().trim();
      const query = this.state?.searchQuery.toLowerCase();

      return (
        (email.includes(query) || fullName.includes(query)) &&
        (selectedStatusFilter === '' || statusChange === selectedStatusFilter)
      );
    });

    const filteredRows = sortedRows.filter((row: any) => {
      const filter = this.state.isRoUserFilter;

      if (filter === 'All') {
        return true;
      }

      if (filter === 'true') {
        return row.IsRoUser === true;
      }

      if (filter === 'false') {
        return row.IsRoUser === false;
      }

      return true;
    });

    const visibleRows = orderBy
      ? filteredRows.slice().sort(getComparator<Row>(order, orderBy, roles))
      : filteredRows;

    const columnWidths = {
      vchFname: 130,
      vchEmail: 170,
      RoleID: 100,
      BranchCode: 140,
      AuthType: 150,
      SendEmail: 100,
      Status: 120,
      IsRoUser: 120,
      Actions: 130
    };

    return (
      <>
        {loading && (
          <Box sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            zIndex: 9999
          }}>
            <div className="loader"></div>
          </Box>
        )}

        <GridTable displaysidebar={displaysidebar}>
          <Grid container spacing={2} alignItems="center" wrap="nowrap">
            <Grid item lg={3}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <TextField
                  size="small"
                  placeholder="Search by UserName or Email"
                  value={this.state.searchTerm}
                  onChange={this.handleSearchChange}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      this.handleSearchClick();
                    }
                  }}
                  fullWidth
                  sx={{
                    '& .MuiInputBase-input::placeholder': {
                      fontSize: '11px',
                    },
                    '& .MuiInputBase-input': {
                      fontSize: '11px',
                    },
                  }}
                />
                <Tooltip title="Click here for search result">
                  <IconButton
                    onClick={this.handleSearchClick}
                    sx={{
                      height: 33,
                      border: '0.2px solid #d0bcbca1',
                      borderRadius: '9%',
                      marginLeft: '-0.6px'
                    }}
                  >
                    <Search fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>
            </Grid>
            <Grid item lg={1.5}>
              <Button
                startIcon={<AddIcon />}
                variant="contained"
                sx={{
                  backgroundColor: "#1976d2",
                  color: "white",
                  px: 1.5,
                  width: '100%',
                  fontWeight: "bold",
                  padding: "8px 8px",
                  textTransform: "none",
                  borderRadius: "8px",
                  transition: "0.3s",
                  height: '30px',
                  "&:hover": {
                    backgroundColor: "#1565c0",
                  },
                }}
                onClick={this.handleAddClick}
              // disabled={broker <= 0}
              >
                Create
              </Button>
            </Grid>
            <Grid item lg={1.5}>
              <Button
                variant="outlined"
                sx={{
                  backgroundColor: "white",
                  color: "black",
                  px: 1.5,
                  width: '100%',
                  fontWeight: "bold",
                  padding: "8px 8px",
                  textTransform: "none",
                  borderRadius: "8px",
                  transition: "0.3s",
                  height: '30px'
                }}
                onClick={this.handleExportExcel}
              >
                Export
              </Button>
            </Grid>
            <Grid item lg={5} />
            <Grid item lg={1} >
              <Refresh
                sx={{
                  cursor: 'pointer',
                  color: 'blue',
                  border: '0.1px solid black',
                  borderRadius: '4px',
                  padding: '3px',
                  height: 30,
                  mt: 1,
                  width: 30,
                }}
                onClick={this.handleSearchClick}
              />
            </Grid>
          </Grid>

          <Paper sx={{ width: '100%', marginTop: '20px', overflow: 'hidden', border: '0.5px solid #7a6e6e54' }}>
            <Box sx={{ maxHeight: 400, overflowX: 'auto' }}>
              <TableContainer sx={{ minWidth: 'max-content' }}>
                <Table stickyHeader sx={{ height: "50px", }} size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontSize: '11px', width: 60, fontWeight: 'bold', textAlign: 'center' }}>S.No</TableCell>
                      {headCells?.map((headCell) => (
                        <TableCell
                          key={headCell.id}
                          sx={{
                            fontSize: '12px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            width: columnWidths[headCell.id as keyof typeof columnWidths] || 190,
                            maxWidth: columnWidths[headCell.id as keyof typeof columnWidths] || 190
                          }}
                          sortDirection={orderBy === headCell.id ? order : false}
                        >
                          {headCell.id === 'IsRoUser' ? (
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 0.5
                              }}
                            >
                              {/* <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={() => this.handleRequestSort(headCell.id)}
                          > */}
                              {headCell.label}
                              {/* </TableSortLabel> */}

                              {/* Filter Icon */}
                              {/* <Tooltip title="Filter IsRoUser">
                            <IconButton
                              size="small"
                              onClick={this.handleIsRoUserFilterClick}
                              sx={{
                                padding: '2px',
                                color:
                                  this.state.isRoUserFilter !== 'All'
                                    ? '#1976d2'
                                    : '#666',
                                '&:hover': {
                                  backgroundColor: 'rgba(25, 118, 210, 0.08)'
                                }
                              }}
                            >
                              <FilterListIcon sx={{ fontSize: '16px' }} />
                            </IconButton>
                          </Tooltip> */}

                              {/* Filter Menu */}
                              {/* <Menu
                            anchorEl={this.state.isRoUserFilterAnchor}
                            open={Boolean(this.state.isRoUserFilterAnchor)}
                            onClose={this.handleIsRoUserFilterClose}
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'center'
                            }}
                            transformOrigin={{
                              vertical: 'top',
                              horizontal: 'center'
                            }}
                            PaperProps={{
                              sx: {
                                mt: 0.5,
                                minWidth: 130,
                                borderRadius: '8px',
                                boxShadow: '0px 4px 15px rgba(0,0,0,0.15)',
                                '& .MuiMenuItem-root': {
                                  fontSize: '12px',
                                  minHeight: '34px',
                                  px: 1.5
                                }
                              }
                            }}
                          >
                            <MenuItem
                              selected={this.state.isRoUserFilter === 'All'}
                              onClick={() =>
                                this.handleIsRoUserFilterChange('All')
                              }
                            >
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 1
                                }}
                              >
                                <span>All</span>
                              </Box>
                            </MenuItem>

                            <MenuItem
                              selected={this.state.isRoUserFilter === 'true'}
                              onClick={() =>
                                this.handleIsRoUserFilterChange('true')
                              }
                            >
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 1
                                }}
                              >
                                <span>True</span>
                              </Box>
                            </MenuItem>

                            <MenuItem
                              selected={this.state.isRoUserFilter === 'false'}
                              onClick={() =>
                                this.handleIsRoUserFilterChange('false')
                              }
                            >
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 1
                                }}
                              >
                               
                                <span>False</span>
                              </Box>
                            </MenuItem>
                          </Menu> */}
                            </Box>
                          ) : (
                            headCell.disableSort ? (
                              headCell.label
                            ) : (
                              <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={() => this.handleRequestSort(headCell.id)}
                              >
                                {headCell.label}
                              </TableSortLabel>
                            )
                          )}
                        </TableCell>
                      ))}

                      {/* <TableCell sx={{ fontSize: '11px', width: 130 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          Status
                          <span style={{ display: 'inline-block' }}>
                            <IconButton
                              size="small"
                              onClick={this.handleStatusFilterClick}
                              sx={{ height: '11px' }}
                            >
                              <FilterAlt fontSize="small" />
                            </IconButton>
                          </span>
                        </Box>
                        <Menu
                          anchorEl={this.state.statusFilterAnchorEl}
                          open={Boolean(this.state.statusFilterAnchorEl)}
                          onClose={this.handleStatusFilterClose}
                          MenuListProps={{ dense: true }}
                        >
                          <MenuItem
                            onClick={() => this.handleStatusFilterSelect('')}
                            selected={this.state.selectedStatusFilter === ''}
                          >
                            All
                          </MenuItem>
                          {['Active', 'InActive'].map((status) => (
                            <MenuItem
                              key={status}
                              onClick={() => this.handleStatusFilterSelect(status)}
                              selected={this.state.selectedStatusFilter === status}
                            >
                              {status}
                            </MenuItem>
                          ))}
                        </Menu>
                      </TableCell> */}
                    </TableRow>
                  </TableHead>
                </Table>

                {/* Scrollable Table Body */}
                <Box sx={{ maxHeight: 310, overflowY: 'auto', overflowX: 'auto', scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none', }, }}>
                  <Table size="small">
                    <TableBody>
                      {visibleRows.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={headCells.length + 3} align="center"
                            sx={{
                              fontSize: '14px',
                              fontWeight: 500,
                              color: 'gray',
                              padding: '20px',
                              borderBottom: 'none',
                            }}>
                            No records to display
                          </TableCell>
                        </TableRow>
                      ) : (
                        visibleRows?.map((row, index) => {
                          return (
                            <TableRow
                              hover
                              key={row.ID}
                            >
                              <TableCell sx={{ fontSize: '11px', width: 60, textAlign: "center" }}>{page * rowsPerPage + index + 1}</TableCell>
                              <TableCell sx={{ fontSize: '11px', width: columnWidths.vchFname, textAlign: "center" }}>{`${row.vchFname || ''} ${row.vchLname || ''}`?.trim()}</TableCell>
                              <TableCell sx={{ fontSize: '11px', width: columnWidths.vchEmail, textAlign: 'center', whiteSpace: 'normal', wordBreak: 'break-all', }}>{row.vchEmail}</TableCell>
                              <TableCell sx={{ fontSize: '11px', width: columnWidths.RoleID, textAlign: "center" }}>{UserRole[row.RoleID]}</TableCell>
                              <TableCell sx={{ fontSize: '11px', width: columnWidths.BranchCode, textAlign: "center" }}>{row.BranchCode}</TableCell>
                              <TableCell sx={{ fontSize: '11px', width: columnWidths.AuthType, textAlign: "center", }}>{row.AuthType}</TableCell>
                              <TableCell sx={{ fontSize: '11px', width: columnWidths.SendEmail, textAlign: "center", }}>{row.SendEmail ? 'true' : 'false'}</TableCell>
                              <TableCell sx={{ width: 120, textAlign: "center", alignContent: 'center', }}>
                                <Chip
                                  label={row.bitActive ? 'Active' : 'Inactive'}
                                  size="small"
                                  sx={{
                                    backgroundColor: row.bitActive ? "#ECFDF5" : "#FEE2E2",
                                    color: row.bitActive ? "#047857" : "#B91C1C",
                                    fontWeight: "bold",
                                    fontSize: '11px',
                                    borderRadius: "12px",
                                  }}
                                />
                              </TableCell>
                              <TableCell sx={{ fontSize: '11px', width: columnWidths.IsRoUser, textAlign: "center", }}>{row.IsRoUser ? 'true' : 'false'}</TableCell>
                              <TableCell sx={{ width: columnWidths.Actions, textAlign: "center", }}>
                                {UserId && UserId !== row.ID ? (
                                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0, flexWrap: 'nowrap' }}>
                                    <IconButton onClick={this.handleOpenEditDrawer(row.ID)}
                                      disabled={!row.bitActive}
                                    >
                                      <EditIcon fontSize="small" />
                                    </IconButton>

                                    <Tooltip title={broker <= 0 ? "" : "Click here to Active/Deactivate user"}>
                                      <span>
                                        {row.bitActive ? (
                                          <IconButton onClick={() => this.handleOpenConfirmDialog(row)}
                                          // disabled={broker <= 0}
                                          >
                                            <Cancel fontSize="small" sx={{ color: '#cf6767' }} />   {/* broker <= 0 ? 'rgba(0, 0, 0, 0.12)' : */}
                                          </IconButton>
                                        ) : (
                                          <IconButton onClick={() => this.handleOpenConfirmDialog(row)}
                                          // disabled={broker <= 0}
                                          >
                                            <CheckCircle fontSize="small" sx={{ color: '#6fd96f' }} /> {/* broker <= 0 ? 'rgba(0, 0, 0, 0.12)' : */}
                                          </IconButton>
                                        )}
                                      </span>
                                    </Tooltip>
                                    <IconButton
                                      onClick={(event) => this.handleViewUser(row, event)}
                                      size="small"
                                      sx={{
                                        color: '#1976d2',
                                        '&:hover': {
                                          backgroundColor: 'rgba(25, 118, 210, 0.08)'
                                        }
                                      }}
                                    >
                                      <VisibilityIcon fontSize="small" />
                                    </IconButton>
                                  </Box>
                                ) : (null)}
                              </TableCell>
                            </TableRow>
                          );
                        })
                      )}
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>
              <Modal open={modalReportUserOpen} onClose={this.handleCloseReportingUsers}>
                <Box sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  height: 'auto',
                  maxHeight: '90%',
                  width: '70%',
                  overflow: 'auto',
                  transform: 'translate(-50%, -50%)',
                  bgcolor: 'background.paper',
                  boxShadow: 24,
                  padding: '15px',
                  borderRadius: 2
                }}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                        <Grid item>
                          <Typography variant="body1" sx={{ wordBreak: 'break-all' }}>
                            Reporting User - {this.state.selectedRUser?.vchEmail}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <IconButton
                            size="small"
                            onClick={this.handleCloseReportingUsers}
                            sx={{
                              padding: '6px',
                              color: '#a8a7a6',
                            }}
                          >
                            <CloseIcon sx={{ fontSize: 20 }} />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px', fontWeight: 'bold' }}>S.No</TableCell>
                        <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px', fontWeight: 'bold' }}>User Name</TableCell>
                        <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px', fontWeight: 'bold' }}>Role</TableCell>
                        <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px', fontWeight: 'bold' }}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {pagedReportUsers.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={4} align="center" sx={{ fontSize: '12px' }}>
                            No reporting users found
                          </TableCell>
                        </TableRow>
                      ) : (
                        pagedReportUsers?.map((user: any, index: number) => (
                          <TableRow key={user.ID || index}>
                            <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px' }}>{reportPage * reportRowsPerPage + index + 1}</TableCell>
                            <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px', wordBreak: 'break-all' }}>{user.vchEmail || user.vchFname || user.vchUser_Name || '-'}</TableCell>
                            <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px', wordBreak: 'break-all' }}>{this.getRoleName(user?.RoleID)}</TableCell>
                              <TableCell sx={{ border: '1px solid #ddd', fontSize: '11px' }}>
                                {this.state?.selectedRUser?.IsRoUser === true && (
                                  <Tooltip title="Remove reporting user">
                                    <IconButton
                                      size="small"
                                      // onClick={() => this.handleRemoveReportingUser(user)}
                                      onClick={() => this.handleDeleteConfirmation(user)}
                                      sx={{
                                        padding: '3px',
                                        color: '#d9534f',
                                      }}
                                    >
                                      <Delete sx={{ fontSize: 20 }} />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 20, 50]}
                    component="div"
                    count={(roReportUsers || []).length}
                    rowsPerPage={reportRowsPerPage}
                    page={reportPage}
                    onPageChange={this.handleReportPageChange}
                    onRowsPerPageChange={this.handleReportRowsPerPageChange}
                  />
                </Box>
              </Modal>
            </Box>

            <TablePagination
              rowsPerPageOptions={[5, 10, 20, 50, 100]}
              component="div"
              count={(this.state?.searchQuery != "" || selectedStatusFilter != "") ? sortedRows?.length : totalCount}

              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={this.handleChangePage}
              onRowsPerPageChange={this.handleChangeRowsPerPage}
            />
          </Paper>

          {/* MODEL FOR CREATING OR EDITING ROW */}
          <Modal open={modalOpen} onClose={this.handleCloseModal}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: '50%',
                maxHeight: '90vh',
                bgcolor: "background.paper",
                boxShadow: 24,
                p: 4,
                borderRadius: 2,
                overflowY: "auto",
              }}
            >
              <Typography sx={{ fontSize: '18px' }}>{editMode ? "Edit User" : "Create New User"}</Typography>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    label="Email"
                    value={selectedRow?.vchEmail || ""}
                    onChange={(e) => {
                      const email = e.target.value;
                      this.handleFormChange("vchEmail", email);
                      this.clearValidationError("vchEmail");
                      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                      const isValid = emailRegex.test(email);
                      this.setState({ emailError: isValid ? "" : "Invalid email format" });
                    }}
                    fullWidth
                    disabled={editMode}
                    error={
                      Boolean(this.state.validationErrors?.vchEmail) ||
                      Boolean(this.state.emailError)
                    }
                    helperText={
                      this.state.validationErrors?.vchEmail ||
                      this.state.emailError
                    }
                    sx={{
                      ...textFieldStyles,
                      "& .MuiInputLabel-root": {
                        position: "relative",
                        top: "16px",
                        fontSize: "10px",
                      },
                      "& .MuiInputBase-root": {
                        height: "45px",
                        fontSize: "12px",
                      },
                    }}
                    FormHelperTextProps={{
                      sx: {
                        color: '#f91010',
                        marginLeft: '5px',
                        fontSize: 'xx-small',
                      },
                    }}
                  />

                  <FormControl fullWidth error={Boolean(this.state.validationErrors?.RoleID)} sx={{
                    top: '14px'
                  }}>
                    <Select
                      displayEmpty
                      value={selectedRow?.RoleID?.toString() || ""}
                      onChange={(e) => { this.handleFormChange("RoleID", Number(e.target.value)); this.clearValidationError("RoleID"); this.clearRoUsers(Number(e.target.value)) }}
                      sx={{
                        ...selectStyles,
                        height: '45px',
                        minHeight: 'unset',
                        '& .MuiSelect-select': {
                          padding: '6px 8px',
                        }
                      }}
                      renderValue={(value) => {
                        const selectedRole = roles?.find(role => role?.RoleId === Number(value));
                        return value && selectedRole ? selectedRole?.RoleName : <span style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '12px' }}>Select Role</span>;
                      }}
                    >
                      {roles
                        .filter(role => {
                          // if (broker > 0 && broker === 1003) {
                          //   return ['CSR', 'Broker Admin']?.includes(role.RoleName) && role.IsActive;
                          // } else if (broker > 0 && broker !== 1003) {
                          //   return !['CSR', 'Broker Admin']?.includes(role.RoleName) && role.IsActive;
                          // }
                          if (this.state.Role_Id === UserRole?.BrokerAdmin || this.state.Role_Id === UserRole?.CSR) {
                            return ['CSR', 'Broker Admin'].includes(role.RoleName) && role.IsActive;
                          } else {
                            return ['Exdion Admin', 'MS User', 'QA', 'Reviewer', 'Supervisor'].includes(role.RoleName) && role.IsActive;
                          }
                        })
                        .map(role => (
                          <MenuItem key={role.RoleId} value={role.RoleId.toString()}>
                            {role.RoleName}
                          </MenuItem>
                        ))}
                    </Select>
                    {this.state.validationErrors?.RoleID && (
                      <Typography variant="caption" color="error" sx={{
                        color: 'red',
                        marginLeft: '5px',
                        fontSize: 'xx-small',
                      }}>{this.state.validationErrors?.RoleID}</Typography>
                    )}
                  </FormControl>
                </Box>

                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField label="First Name" value={selectedRow?.vchFname || ""} onChange={(e) => { this.handleFormChange("vchFname", e.target.value); this.clearValidationError("vchFname"); }} error={Boolean(this.state.validationErrors?.vchFname)} helperText={this.state.validationErrors?.vchFname} fullWidth sx={{
                    ...textFieldStyles,
                    "& .MuiInputLabel-root": {
                      position: "relative",
                      top: "16px",
                      fontSize: "10px",
                    },
                    "& .MuiInputBase-root": {
                      height: "45px",
                      fontSize: "12px",
                    },
                  }}
                    FormHelperTextProps={{
                      sx: {
                        color: '#f91010',
                        marginLeft: '5px',
                        fontSize: 'xx-small',
                      },
                    }} />
                  <TextField label="Middle Name" value={selectedRow?.vchMname || ""} onChange={(e) => this.handleFormChange("vchMname", e.target.value)} fullWidth sx={{
                    ...textFieldStyles,
                    "& .MuiInputLabel-root": {
                      position: "relative",
                      top: "16px",
                      fontSize: "10px",
                    },
                    "& .MuiInputBase-root": {
                      height: "45px",
                      fontSize: "12px",
                    },
                  }} />
                  <TextField label="Last Name" value={selectedRow?.vchLname || ""} onChange={(e) => { this.handleFormChange("vchLname", e.target.value); this.clearValidationError("vchLname"); }} error={Boolean(this.state.validationErrors?.vchLname)} helperText={this.state.validationErrors?.vchLname} fullWidth sx={{
                    ...textFieldStyles,
                    "& .MuiInputLabel-root": {
                      position: "relative",
                      top: "16px",
                      fontSize: "10px",
                    },
                    "& .MuiInputBase-root": {
                      height: "45px",
                      fontSize: "12px",
                    },
                  }}
                    FormHelperTextProps={{
                      sx: {
                        color: '#f91010',
                        marginLeft: '5px',
                        fontSize: 'xx-small',
                      },
                    }} />
                </Box>

                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    label="Phone"
                    value={selectedRow?.vchMobile || ""}
                    onChange={(e) => {
                      const input = e.target.value;
                      if (/^\d{0,10}$/.test(input)) {
                        this.handleFormChange("vchMobile", input);
                        if (input.length === 10) {
                          const isValid = /^\d{10}$/.test(input);
                          this.setState({ noError: isValid ? "" : "" });
                        } else {
                          this.setState({ noError: "Phone number must be exactly 10 digits" });
                        }
                      }
                    }}
                    fullWidth
                    error={Boolean(this.state.noError)}
                    helperText={this.state.noError}
                    sx={{
                      ...textFieldStyles,
                      "& .MuiInputLabel-root": {
                        position: "relative",
                        top: "16px",
                        fontSize: "10px",
                      },
                      "& .MuiInputBase-root": {
                        height: "45px",
                        fontSize: "12px",
                      },
                    }}
                    inputProps={{
                      maxLength: 10,
                      inputMode: 'numeric',
                      pattern: '[0-9]*',
                    }}
                  />

                  <TextField
                    label="Branch Code"
                    fullWidth
                    value={selectedRow?.BranchCode || ""}
                    onChange={(e) => this.handleFormChange("BranchCode", e.target.value)}
                    sx={{
                      ...textFieldStyles,
                      "& .MuiInputBase-root": {
                        height: "45px",
                        fontSize: "12px",
                      },
                      "& .MuiInputLabel-root": {
                        position: "relative",
                        top: "16px",
                        fontSize: "10px",
                      },
                    }}
                  />

                  <FormControl fullWidth error={Boolean(this.state.validationErrors?.AuthType)} sx={{
                    marginTop: '16px'
                  }}>
                    <Select
                      displayEmpty
                      value={selectedRow?.AuthType?.toString() || ""}
                      onChange={(e) => {
                        const selected = e.target.value;
                        this.handleFormChange("AuthType", selected);
                        this.clearValidationError("AuthType");
                        this.setState({ aliasEmails: selected === 'Microsoft Entra ID' ? [''] : [] });
                      }}
                      sx={{
                        ...selectStyles,
                        height: '45px',
                        minHeight: 'unset',
                        '& .MuiSelect-select': {
                          padding: '6px 8px',
                        }
                      }}
                      renderValue={(selected) => {
                        if (!selected) return <span style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '12px' }}>Select AuthType</span>;
                        return selected;
                      }}
                    >
                      <MenuItem value="App Authentication">App Authentication</MenuItem>
                      <MenuItem value="Microsoft Entra ID">Microsoft Entra ID</MenuItem>
                    </Select>
                    {this.state.validationErrors?.AuthType && (
                      <Typography variant="caption" color="error" sx={{
                        color: 'red',
                        marginLeft: '5px',
                        fontSize: 'xx-small',
                      }}>{this.state.validationErrors?.AuthType}</Typography>
                    )}
                  </FormControl>
                </Box>

                <Box sx={{ width: "100%", marginTop: "2px" }}>
                  {/* Is RO + Reporting RO */}
                  {this.RoUserEnabledRoles?.includes(selectedRow?.RoleID) && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        width: "100%",
                      }}
                    >
                      {/* Left side - Is RO */}
                      <Box
                        sx={{
                          width: "172px",
                          flexShrink: 0,
                          paddingTop: "28px",
                        }}
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedRow?.IsRoUser || false}
                              // disabled={
                              //   !(
                              //     this.RoUserEnabledRoles?.includes(Role_Id) &&
                              //     (
                              //       selectedRow?.RoleID == 0 ||
                              //       this.RoUserEnabledRoles?.includes(selectedRow?.RoleID)
                              //     )
                              //   )
                              // }
                              onChange={(e) => {
                                const isRoUser = e.target.checked;
                                this.handleFormChange("IsRoUser", isRoUser);

                                if (isRoUser) {
                                  this.handleFormChange("ReportingToUser", 0);
                                  this.clearValidationError("ReportingToUser");
                                }
                              }}
                              sx={{
                                padding: 0,
                                marginRight: "6px",
                                "& .MuiSvgIcon-root": {
                                  fontSize: 22,
                                },
                              }}
                            />
                          }
                          label="Is RO"
                          sx={{
                            margin: 0,
                            height: "45px",
                            alignItems: "center",

                            "& .MuiFormControlLabel-label": {
                              fontSize: "14px",
                              whiteSpace: "nowrap",
                              lineHeight: 1,
                              marginTop: "3px",
                            },
                          }}
                        />
                      </Box>

                      {/* Right side - Reporting RO */}
                      <FormControl
                        fullWidth
                        error={Boolean(this.state.validationErrors?.RoUserId)}
                        sx={{
                          flex: 1,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "13px",
                            height: "20px",
                            lineHeight: "20px",
                            marginBottom: "8px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Reporting RO
                        </Typography>

                        <Select
                          displayEmpty
                          disabled={selectedRow?.IsRoUser}
                          // disabled={
                          //   !(
                          //     this.RoUserEnabledRoles?.includes(Role_Id) &&
                          //     (
                          //       selectedRow?.RoleID === 0 ||
                          //       this.RoUserEnabledRoles?.includes(selectedRow?.RoleID)
                          //     )
                          //   )
                          // }
                          value={
                            selectedRow?.ReportingToUser
                              ? selectedRow.ReportingToUser
                              : null
                          }
                          onChange={(e) => {
                            this.handleFormChange(
                              "ReportingToUser",
                              Number(e.target.value)
                            );
                            this.clearValidationError("ReportingToUser");
                          }}
                          sx={{
                            ...selectStyles,
                            height: "45px",
                            minHeight: "unset",

                            "& .MuiSelect-select": {
                              padding: "6px 8px",
                              display: "flex",
                              alignItems: "center",
                            },
                          }}
                          renderValue={(value) => {
                            const selectedUser = roUsers?.find(
                              (user) => user?.ID === Number(value)
                            );

                            return value && selectedUser ? (
                              selectedUser.vchEmail
                            ) : (
                              <span
                                style={{
                                  color: "rgba(0, 0, 0, 0.54)",
                                  fontSize: "12px",
                                }}
                              >
                                Select Reporting User
                              </span>
                            );
                          }}
                        >
                          {roUsers?.map((user) => (
                            <MenuItem
                              key={user.ID}
                              value={user.ID.toString()}
                            >
                              {user.vchEmail}
                            </MenuItem>
                          ))}
                        </Select>

                        {this.state.validationErrors?.RoUserId && (
                          <Typography
                            variant="caption"
                            color="error"
                            sx={{
                              marginLeft: "5px",
                              fontSize: "xx-small",
                            }}
                          >
                            {this.state.validationErrors.RoUserId}
                          </Typography>
                        )}
                      </FormControl>
                    </Box>
                  )}

                  {/* Send Welcome Email - aligned with Is RO */}
                  <Box
                    sx={{
                      width: "172px",
                      marginTop: "12px",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedRow?.SendEmail || false}
                          onChange={(e) =>
                            this.handleFormChange(
                              "SendEmail",
                              e.target.checked
                            )
                          }
                          sx={{
                            padding: 0,
                            marginRight: "8px",

                            "& .MuiSvgIcon-root": {
                              fontSize: 20,
                            },
                          }}
                        />
                      }
                      label="Send Welcome Email"
                      sx={{
                        margin: 0,
                        alignItems: "center",

                        "& .MuiFormControlLabel-label": {
                          fontSize: "14px",
                          lineHeight: 1,
                          whiteSpace: "nowrap",
                          marginTop: "3px",
                        },
                      }}
                    />
                  </Box>
                </Box>

                {selectedRow?.AuthType === 'Microsoft Entra ID' && (
                  <Box sx={{ flex: "1 1 100%", mt: 0 }}>
                    <Typography sx={{ fontSize: '12px' }}>
                      Alias Email Addresses
                    </Typography>

                    {aliasEmails?.map((email, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 2,
                          mb: 1,
                          flexWrap: 'wrap',
                        }}
                      >
                        <TextField
                          label={`Alias Email ${index + 1}`}
                          value={email}
                          onChange={async (e) => {
                            const value = e.target.value;
                            const aliasEmails = [...this.state.aliasEmails];
                            aliasEmails[index] = e.target.value;
                            const primaryEmail = this.state.selectedRow?.vchEmail || "";
                            const isDuplicate = e?.target?.value?.trim()?.toLowerCase() === primaryEmail?.trim().toLowerCase();

                            const aliasEmailErrors = [...(this.state.aliasEmailErrors || [])];
                            if (isDuplicate) {
                              aliasEmailErrors[index] = "AliasEmail should not be the same as UserEmail.";
                              alert("AliasEmail should not be the same as UserEmail.");
                              aliasEmails[index] = "";
                              this.setState({ aliasEmails, aliasEmailErrors });
                              return;
                            }
                            // } else {
                            //   aliasEmailErrors[index] = "";
                            // }
                            this.setState({ aliasEmails });

                            if (!this.debounceTimers) this.debounceTimers = {};

                            // clear previous timer
                            if (this.debounceTimers[index]) {
                              clearTimeout(this.debounceTimers[index]);
                            }

                            this.debounceTimers[index] = setTimeout(async () => {
                              if (!value || !value.includes("@")) return; // optional validation
                              this.setState({ loading: true });
                              const response = await getUserExists(value);


                              if (response?.exists) {
                                this.setState({ loading: false });
                                const updatedEmails = [...this.state.aliasEmails];
                                const updatedErrors = [...(this.state.aliasEmailErrors || [])];

                                alert("Primary user not allowed to add as alias");

                                updatedEmails[index] = "";
                                updatedErrors[index] =
                                  "Primary user not allowed to add as alias";

                                this.setState({
                                  aliasEmails: updatedEmails,
                                  aliasEmailErrors: updatedErrors,
                                });

                                return;
                              }
                              const updatedErrors = [...(this.state.aliasEmailErrors || [])];
                              updatedErrors[index] = "";

                              this.setState({ aliasEmailErrors: updatedErrors, loading: false });
                              this.handleFormChange("AliasEmails", this.state.aliasEmails);

                            }, 200);
                          }}

                          disabled={this.state.editMode && !!this.state.initialAliasEmails[index]}
                          sx={{
                            flex: "0 0 50%", "& .MuiInputBase-root": {
                              height: "45px",
                              fontSize: "12px",
                            },
                            "& .MuiInputLabel-root": { position: "relative", top: "16px", fontSize: "10px" },
                            "& .MuiOutlinedInput-input": { padding: "10px 20px" },
                          }}
                        />
                        <Button
                          variant="outlined"
                          color="error"
                          onClick={() => this.removeAliasEmailField(index)}
                          sx={{
                            minWidth: '90px', height: '30px', top: '9px', fontSize: '10px', padding: "8px 8px",
                            textTransform: "none",
                            borderRadius: "8px",
                            transition: "0.3s"
                          }}
                          disabled={aliasEmails.length === 0}
                        >
                          Remove
                        </Button>
                      </Box>
                    ))}

                    <Box sx={{ textAlign: 'left' }}>
                      <Button
                        variant="contained"
                        onClick={this.addAliasEmailField}
                        sx={{
                          backgroundColor: '#2c296c',
                          color: 'white',
                          fontWeight: 'bold',
                          boxShadow: 2,
                          borderRadius: 1.5,
                          fontSize: '10px',
                          mt: 1
                        }}
                      >
                        Add Another Email
                      </Button>
                    </Box>
                  </Box>
                )}

              </Box>

              <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: '8px' }}>
                <Button
                  variant="outlined"
                  sx={{
                    color: "black",
                    fontWeight: "bold",
                    padding: "8px 8px",
                    textTransform: "none",
                    borderRadius: "8px",
                    transition: "0.3s",
                    height: "30px",
                  }}
                  onClick={this.handleCloseModal}
                >
                  Close
                </Button>

                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#1976d2",
                    color: "white",
                    fontWeight: "bold",
                    padding: "8px 8px",
                    textTransform: "none",
                    borderRadius: "8px",
                    transition: "0.3s",
                    height: "30px",
                    marginLeft: 2,
                  }}
                  onClick={this.handleSaveRow}
                // disabled={!this.isFormValid()}
                >
                  {editMode ? "Save" : "Create"}
                </Button>
              </Box>
            </Box>
          </Modal>
        </GridTable >

        {/* Confirmation Dialog For Active/Deactivae Icon*/}
        < Dialog open={confirmDialog} onClose={this.handleCloseConfirmDialog} >
          <DialogContent sx={{
            padding: '0px 20px',
            paddingTop: '25px',
            paddingBottom: '35px',
            textAlign: 'center',
          }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                mb: 2,
              }}
            >
              {iconData ? (
                <Box
                  sx={{
                    backgroundColor: '#FEE2E2',
                    borderRadius: '50%',
                    width: 60,
                    height: 60,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Cancel sx={{ color: '#B91C1C', fontSize: 30 }} />
                </Box>
              ) : (
                <Box
                  sx={{
                    backgroundColor: '#ECFDF5',
                    borderRadius: '50%',
                    width: 60,
                    height: 60,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <CheckCircle sx={{ color: '#6fd96f', fontSize: 30 }} />
                </Box>
              )}
            </Box>
            {/* <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.25rem', p: 0 }}>
              Activate/Deactivate User
            </DialogTitle> */}
            <DialogContentText sx={{ textAlign: 'center', mt: 1, mb: 3, fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.7)' }}>
              Are you sure want to {iconData ? 'Deactivate' : 'Activate'} the user.
            </DialogContentText>
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, height: '30px' }}>
              <Button
                variant="contained"
                sx={{
                  px: 4,
                  borderRadius: '6px',
                }}
                onClick={() => this.handleActivateUsers(iconData ? false : true)}
              >
                Yes
              </Button>
              <Button
                onClick={this.handleCloseConfirmDialog}
                sx={{
                  color: '#007bff',
                  borderColor: '#007bff',
                  border: '0.5px solid #53494987',
                  px: 4,
                  borderRadius: '6px',
                  '&:hover': {
                    borderColor: '#0056b3',
                    color: '#0056b3',
                  },
                }}
              >
                No
              </Button>
            </Box>
          </DialogContent>
        </Dialog >

        <ConfirmationDialogComponent open={confirmationDialog.isOpen} message={confirmationDialog.message} onConfirm={() => { this.onConfirmationDialog() }} onClose={() => {
          this.setState({
            confirmationDialog: {
              isOpen: false,
              recordId: 0,
              message: "",
              activate: false,
              isDelete: false
            }
          });
        }} />
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={this.handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert severity={snackbarSeverity} onClose={this.handleCloseSnackbar}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </>
    );
  }
}

export default UserMaster;
